module.exports = __webpack_public_path__ + "static/media/Photo7.841df6ce.jpg";